export function getUmbracoMediaUrl(url?: string) {
  const GRAPHQL_URL = process.env.GRAPHQL_URL?.replace("/graphql", "")
  if (!url) {
    return ""
  }

  if (url.startsWith("/media/")) {
    return GRAPHQL_URL?.endsWith("/")
      ? `${GRAPHQL_URL}${url.substring(1)}`
      : `${GRAPHQL_URL}${url}`
  }

  // If it's an absolute URL, just ensure it uses HTTPS
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url.replace(/^http:\/\//, "https://")
  }

  return url
}
